export class ErrorCode extends Error {
}
ErrorCode.NAME_UNKNOWN = 'unknown';
ErrorCode.CODE_UNKNOWN = 13000;
ErrorCode.NAME_TIMEOUT = 'timeout';
ErrorCode.CODE_TIMEOUT = 13001;
ErrorCode.NAME_WEBRTC_DISCONNECTED = 'webrtc_disconnected';
ErrorCode.CODE_WEBRTC_DISCONNECTED = 13002;
ErrorCode.NAME_RETRY_LIMIT_REACH = 'retry_limit_reach';
ErrorCode.CODE_RETRY_LIMIT_REACH = 13003;
ErrorCode.MSG_ERR = 'An error occurred.';
ErrorCode.MSG_WEBRTC_DISCONNECTED = 'The webrtc is disconnected.';
